import { render, staticRenderFns } from "./TheCustomersPerProduct.vue?vue&type=template&id=123f3d4e&"
import script from "./TheCustomersPerProduct.vue?vue&type=script&lang=js&"
export * from "./TheCustomersPerProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
